import { Logo } from './components/Logo';
import { Login } from './screens/Login';
import { Shell } from './screens/Shell';
import { useSession } from './state/session';

export function App() {
  const session = useSession();
  if (session.status === 'loading') {
    return (
      <div className="grid h-full place-items-center" aria-busy="true">
        <Logo size={56} className="animate-pulse" />
      </div>
    );
  }
  if (session.status === 'signed-out') return <Login reason={session.reason} />;
  return <Shell user={session.user} />;
}
